import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

interface IGoldBindingCumulativeTotalRequest {
    page: number;
    size: number;
    orderByDesc: boolean;
    orderBy: string;
    status: string;
    merchantIds: string;
    startDate: Date | string;
    endDate: Date | string;
}

async function getGoldBindingCumulativeTotal(params: IGoldBindingCumulativeTotalRequest): Promise<any> {
    try {
        return (await axiosInstance.post("/MerchantCurrentBalanceMovement/GetGoldBindingCumulativeTotal", params))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetGoldBindingCumulativeTotal() {
    return useMutation<any, Error, IGoldBindingCumulativeTotalRequest>(
        (params) => getGoldBindingCumulativeTotal(params)
    );
}